import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Bolet molt petit (0,3 a 0,7 cm de diàmetre) i espectacular sense peu i amb el marge de la fructificació blanquinós, crenat en forma de triangle irregular. L’himeni crida l’atenció pel color vermell molt viu i granulós al igual que la superficie externa però aquesta és més pàl·lida. Les espores són rodones i amb gota lipídica, primer llises i després formen un reticle de xarxa poligonal i irregular, de 12-14 micres.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      